import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@store/types';

import { normalizeLauncherPlacement } from '../components/placement/launcherPlacement';

import type { JotSupportPlacementState } from './placementSlice';

declare module '@store/types' {
  interface DynamicFeatureState {
    jotSupport?: JotSupportPlacementState;
  }
}

export const selectJotSupportPlacement = createSelector(
  [(state: RootState) => state.jotSupport?.placement],
  normalizeLauncherPlacement,
);
